'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

// Dynamically import the SiteHeader component with SSR disabled
const SiteHeader = dynamic(() => import('./SiteHeader'), { ssr: false });

export default function ClientSiteHeader() {
  const [isMounted, setIsMounted] = useState(false);

  // Only render the header on the client side
  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null; // Don't render anything during SSR or before mounting
  }

  return <SiteHeader />;
}
